import { ContactCardItemContainer } from './styles';
import React from 'react';
import { BodyMedium } from '../../../styles';
import { InstitutionIcon } from '../../institution-icon/InstitutionIcon';
import { Institution } from '../../../types/Institution';

type Props = Pick<Institution, 'type' | 'name'>;

export const ContactCardInstitutionItem = ({ type, name }: Props) => {
    return (
        <ContactCardItemContainer>
            <InstitutionIcon type={type} />
            <BodyMedium>{name}</BodyMedium>
        </ContactCardItemContainer>
    );
};
